var meaasgeAlert = function(meaasge) {
    var div = document.createElement('div');
    div.className = "eeo_message";
    if(window.browserVersion.mobile){
        div.className = "eeo_m_message";
    }
    document.body.appendChild(div);
    div.innerHTML = meaasge;
    var timer = setTimeout(function(){
        document.body.removeChild(div);
    },1000)
};
window.meaasgeAlert=meaasgeAlert;

export default meaasgeAlert;